const toPositiveInteger = value => {
  const numeric = Number(value);
  return Number.isInteger(numeric) && numeric > 0 ? numeric : null;
};

export const buildNotificationTargetPath = ({
  caseId,
  applicationId,
  appealId,
  trackingId,
  isCaseManaged = false,
}) => {
  const resolvedApplicationId = toPositiveInteger(applicationId);
  const resolvedAppealId = toPositiveInteger(appealId);
  if (caseId && resolvedAppealId) {
    const params = new URLSearchParams();
    if (resolvedApplicationId) params.set('applicationId', String(resolvedApplicationId));
    params.set('appeal', String(resolvedAppealId));
    return `${resolvedApplicationId ? '/application-case' : '/cases'}/${caseId}?${params.toString()}`;
  }
  if (caseId && resolvedApplicationId) {
    const params = new URLSearchParams({ applicationId: String(resolvedApplicationId) });
    return `/application-case/${caseId}?${params.toString()}`;
  }
  if (caseId) {
    return isCaseManaged ? `/cases/${caseId}` : `/application-case/${caseId}`;
  }
  return trackingId ? `/application-case/${trackingId}` : null;
};
